"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeStatusSchema = exports.RecommendationSchema = exports.DiffLineSchema = exports.LevelSchema = exports.REFUSAL_REASON = exports.REFUSED_CONTENT_KINDS = exports.BilingualTextSchema = void 0;
const zod_1 = require("zod");
const tier_1 = require("./tier");
/**
 * Ràng buộc nội dung — PRS §10.
 * Ba luật này áp ở CẢ tầng prompt lẫn tầng validate. Đừng chỉ dựa vào prompt.
 */
/** Sinh song ngữ bắt buộc: nội dung thiếu một ngôn ngữ sẽ không áp dụng được. */
exports.BilingualTextSchema = zod_1.z.object({
    vi: zod_1.z.string().min(1, 'thiếu bản tiếng Việt'),
    en: zod_1.z.string().min(1, 'thiếu bản tiếng Anh'),
});
/**
 * Loại nội dung Copilot TỪ CHỐI sinh, kể cả khi được yêu cầu:
 * - testimonial/review: phải từ khách hàng thật, có tên và thời điểm
 * - số liệu hiệu quả: phải do người dùng cung cấp, Copilot chỉ định dạng lại
 */
exports.REFUSED_CONTENT_KINDS = ['testimonial', 'review', 'performanceMetric'];
exports.REFUSAL_REASON = {
    testimonial: 'Đánh giá khách hàng phải lấy từ khách hàng thật, có tên và thời điểm. Nội dung bịa vi phạm chính sách Google và gây rủi ro pháp lý.',
    review: 'Tương tự testimonial — không sinh nội dung đánh giá không có nguồn.',
    performanceMetric: 'Số liệu hiệu quả sản phẩm phải do người dùng cung cấp; Copilot chỉ định dạng lại, không tự nghĩ ra.',
};
exports.LevelSchema = zod_1.z.enum(['low', 'medium', 'high']);
/**
 * Một dòng trong phần so sánh trước/sau.
 * `-` là dòng hiện tại bị thay, `+` là dòng đề xuất. Cấu trúc lấy theo mockup
 * của BA, hiển thị đẹp hơn hẳn so với nhét cả khối diff vào một chuỗi.
 */
exports.DiffLineSchema = zod_1.z.object({
    op: zod_1.z.enum(['-', '+']),
    text: zod_1.z.string(),
});
/** Một đề xuất cải thiện — PRS §9. */
exports.RecommendationSchema = zod_1.z.object({
    id: zod_1.z.string(),
    kind: tier_1.ChangeKindSchema,
    tier: tier_1.TierSchema,
    /** Mã mục kiểm tra sinh ra đề xuất này, vd `missing-canonical` */
    checkCode: zod_1.z.string(),
    /** Tiêu đề ngắn, vd "Viết lại Meta Title" */
    title: zod_1.z.string().min(1),
    /** Một dòng nói rõ hơn, vd "Thêm từ khoá chính và chức năng cốt lõi" */
    subtitle: zod_1.z.string(),
    /** Hiện trạng đang sai ở đâu */
    problem: zod_1.z.string().min(1),
    /** Vì sao mục này quan trọng — viết cho người không rành SEO */
    why: zod_1.z.string().min(1),
    priority: exports.LevelSchema,
    impact: exports.LevelSchema,
    /** Vị trí sẽ thay đổi, vd "quangia-pro/index.html · dòng 7" */
    location: zod_1.z.string(),
    diff: zod_1.z.array(exports.DiffLineSchema),
    /** Nội dung đề xuất ở dạng dùng lại được — song ngữ nếu là nội dung hiển thị */
    proposed: zod_1.z.union([exports.BilingualTextSchema, zod_1.z.string()]).nullable(),
});
/** Vòng đời một thay đổi — PRS §11.1. */
exports.ChangeStatusSchema = zod_1.z.enum([
    'proposed',
    'draft',
    'awaiting_approval',
    'blocked_by_invariant',
    'published',
    'reverted',
]);
//# sourceMappingURL=content.js.map